export default "__VITE_ASSET__5Iz3_K3G__"